/**
 * Tela de falha quando o chunk da entrada não baixa (rede caiu, deploy trocou os arquivos).
 * DOM puro, sem React nem PrimeReact e sem a cor da marca: precisa funcionar justamente quando nada carregou.
 */
export function renderLoadError(container: HTMLElement, reload: () => void): void {
  const wrapper = document.createElement('div');
  wrapper.setAttribute('role', 'alert');
  wrapper.style.cssText =
    'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;min-height:60vh;padding:24px;text-align:center;font-family:system-ui,sans-serif;color:#1f2937';

  const message = document.createElement('p');
  message.style.cssText = 'margin:0;font-size:16px;line-height:1.5';
  message.textContent = 'Não foi possível carregar. Recarregue a página.';

  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = 'Recarregar';
  button.style.cssText =
    'padding:8px 16px;border:1px solid #6b7280;border-radius:6px;background:transparent;color:#1f2937;font-size:14px;cursor:pointer';
  button.addEventListener('click', reload);

  wrapper.append(message, button);
  container.replaceChildren(wrapper);
}
